// extracted by mini-css-extract-plugin
export default {"Main":"resetPassword__Main__DJvgW"};